import axios from "axios";

let isSessionExpiredHandled = false;

// Setup global Axios response interceptor for automatic 401 handling
export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const detail = error?.response?.data?.detail;
      const isExpiredMsg =
        typeof detail === "string" &&
        (detail.toLowerCase().includes("expired") ||
          detail.toLowerCase().includes("invalid token") ||
          detail.toLowerCase().includes("access token"));

      if (status === 401 || (status === 403 && isExpiredMsg)) {
        if (!isSessionExpiredHandled) {
          isSessionExpiredHandled = true;
          window.dispatchEvent(new CustomEvent("auth:session-expired"));

          setTimeout(() => {
            isSessionExpiredHandled = false;
          }, 3000);
        }
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;
